import { Col, Row, Select, Tooltip, message } from 'antd'
import * as powerbiClient from 'powerbi-client'
import { models } from 'powerbi-client'
import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import BackNavigation from '../../utils/Components/BackNavigation'
import * as actions from './actions'
import './reports.css'
// Define the Props interface
interface Props {
  orgReportList: any
  context: any
  orgreportAccessGet: Function
  getReportsToken: Function
}
const Reports: React.FC<Props> = (props) => {
  const [selectedReport, setSelectedReport] = useState<string | undefined>(
    undefined,
  )
  const [selectedWorkSpaceId, setSelectedWorkSpaceId] = useState<string | null>(
    null,
  )
  const [selectedReportId, setSelectedReportId] = useState<string | null>(null)
  const [selectedDatasetId, setSelectedDatasetId] = useState<string | null>(
    null,
  )
  const [loading, setLoading] = useState<boolean>(false)
  const [reportsData, setReportsData] = useState<any>(null)
  const { appContext } = props.context
  const [token, setToken] = useState<string | null>(null)
  const [powerBICredentials, setPowerBICredentials] = useState<string | null>(
    null,
  )
  const [isFetched, setIsFetched] = useState<boolean>(false)
  const reportClass = 'powerbi-embed-container'
  const embedContainerRef = useRef<HTMLDivElement | null>(null)
  // Fetch token and report data
  useEffect(() => {
    props.orgreportAccessGet(null, null, null, appContext.orgId)
    props.getReportsToken(null, null, null)
  }, [])
  useEffect(() => {
    if (
      !token &&
      props.orgReportList &&
      props.orgReportList.accessToken.access_token
    ) {
      setToken(props.orgReportList.accessToken.access_token)
    }
    if (
      props.orgReportList.orgReportMappingList && props.orgReportList.orgReportMappingList.length > 0
    ) {
      setSelectedReport(props.orgReportList.orgReportMappingList[0]?.description);
      setSelectedWorkSpaceId(props.orgReportList.orgReportMappingList[0]?.workspaceID)
      setSelectedReportId(props.orgReportList.orgReportMappingList[0]?.reportID)
      setSelectedDatasetId(props.orgReportList.orgReportMappingList[0]?.datasetID)
    }
  }, [props.orgReportList, props.orgReportList.orgReportMappingList, token])
  useEffect(() => {
    if (token && selectedWorkSpaceId && !isFetched) {
      fetchReportsData(token, selectedWorkSpaceId)
    }
  }, [token, selectedWorkSpaceId, isFetched])
  const fetchReportsData = async (token: string, workspaceId: string) => {
    if (!token) {
      message.error('Access token is missing.')
      return
    }
    try {
      setLoading(true)
      const response = await fetch(
        `https://api.powerbi.com/v1.0/myorg/groups/${workspaceId}/reports`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      const data = await response.json()
      if (response.ok) {
        setReportsData(data.value)
        setIsFetched(true)
      } else {
        throw new Error(data.error.message || 'Failed to fetch reports')
      }
    } catch (error) {
      setLoading(false)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    if (reportsData && reportsData.length > 0 && !selectedReport) {
      const firstReport = reportsData[0]
      setSelectedReport(firstReport.description)
      setSelectedWorkSpaceId(firstReport.workspaceID)
      setSelectedReportId(firstReport.reportID)
      setSelectedDatasetId(firstReport.datasetID)
    }
  }, [reportsData, selectedReport])
  const selectOptions = props.orgReportList.orgReportMappingList.map(
    (report: any) => ({
      value: report.description,
      label: report.description,
    }),
  )
  const handleSelectChange = (value: string) => {
    setSelectedReport(value)
    setLoading(true)
    const selectedReport = props.orgReportList.orgReportMappingList.find(
      (report: any) => report.description === value,
    )
    console.log("selectedReport:" + selectedReport);
    if (selectedReport) {
      setSelectedWorkSpaceId(selectedReport.workspaceID)
      setSelectedReportId(selectedReport.reportID)
      setSelectedDatasetId(selectedReport.datasetID)
      setPowerBICredentials(null)
      setIsFetched(false) // To trigger fetching of new report data
    }
  }
  useEffect(() => {
    if (selectedReportId && selectedWorkSpaceId && token) {
      setPowerBICredentials(null)
      generatePowerBIToken()
    }
  }, [selectedReportId, selectedWorkSpaceId, token])
  const generatePowerBIToken = async () => {
    let accessToken = token
    if (!accessToken) {
      accessToken = props.orgReportList.accessToken.access_token;
    }
    if (!selectedWorkSpaceId || !selectedReportId || !accessToken) {
      message.error('Missing necessary data for token generation.')
      return
    }
    let contextUserId = appContext.userId
    let contextOrgId = appContext.orgId
    let selectedReportDatasetID = selectedDatasetId
    // Define requestBody as a global variable
    let requestBody = {
      accessLevel: 'View',
      identities: [
        {
          username: contextOrgId, // Initially set to contextOrgId
          roles: ['OrgID', 'Role2'],
          datasets: [selectedReportDatasetID],
        },
      ],
    }
    // Check for the specific conditions to modify contextOrgId
    const reportName = selectedReport // This will be the name of the selected report
    const parkerOrgId = 'c6adcb40-be92-11e6-9ed6-a5bc9cb5279b'
    // ePTO/PX condition
    if (
      (reportName === 'ePTO' ||
        reportName === 'PX Report' ||
        reportName === 'ePTO Extended' ||
        reportName === 'State Of Charge') &&
      contextOrgId === parkerOrgId
    ) {
      contextOrgId = '925a4395-11c8-4497-9174-66ba6cf10bfc' // Set to Viatec org ID
      // Update the requestBody to reflect the new contextOrgId
      requestBody.identities[0].username = contextOrgId
    }
    // Toyota Reports condition
    else if (
      (reportName === 'Utilization' ||
        reportName === 'PM' ||
        reportName === 'Operator Checklist' ||
        reportName === 'Incident' ||
        reportName === 'Tire Summary') &&
      contextOrgId === parkerOrgId
    ) {
      contextOrgId = '7ff34c90-36b2-11e8-8e2e-6f1fbe0d469d' // Set to Toyota org ID
      // Update the requestBody to reflect the new contextOrgId
      requestBody.identities[0].username = contextOrgId
    }
    // Default condition where requestBody is modified based on user and report
    else {
      // Additional conditions based on reportName
      if (
        appContext.mode !== 'support' &&
        appContext.userId != null &&
        reportName !== 'IQANBilling' &&
        contextOrgId !== parkerOrgId
      ) {
        contextOrgId = contextUserId // Set contextOrgId to contextUserId for these conditions
        // Update the requestBody to reflect the new contextOrgId
        requestBody = {
          accessLevel: 'View',
          identities: [
            {
              username: contextOrgId, // Set updated contextOrgId here
              roles: ['UserOrgs'],
              datasets: [selectedReportDatasetID],
            },
          ],
        }
      }
    }
    // console.log(requestBody)
    try {
      const response = await fetch(
        `https://api.powerbi.com/v1.0/myorg/groups/${selectedWorkSpaceId}/reports/${selectedReportId}/GenerateToken`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(requestBody),
        },
      )
      const data = await response.json()
      if (response.ok) {
        setPowerBICredentials(data.token)
      }
    } catch (error) {
      //message.error(`Error generating token: ${error.message}`);
    }
  }
  // Embed Power BI Report using the powerbi-client
  const embedReport = async () => {
    if (
      !embedContainerRef.current ||
      !powerBICredentials ||
      !selectedReportId
    ) {
      return
    }
    const embedConfig = {
      type: 'report',
      id: selectedReportId || '',
      embedUrl:
        reportsData?.find((report: any) => report.id === selectedReportId)
          ?.embedUrl || '',
      accessToken: powerBICredentials || '',
      tokenType: models.TokenType.Embed,
      settings: {
        panes: {
          filters: { expanded: false, visible: false },
        },
      },
    }
    // Check if the report description is "GatewayService" or "IQANBilling" and enable the filter pane
    // console.log("reportsData:"+JSON.stringify(reportsData));
    const selectedReportData = reportsData?.find(
      (report: any) => report.id === selectedReportId,
    )
    console.log("selectedReportId:"+selectedReportId);
    console.log("selectedReportData.name:"+selectedReportData.name);
    if (
      selectedReportData &&
      (selectedReportData.name === 'GatewayService' ||
        selectedReportData.name === 'IQANBilling')
    ) {
      embedConfig.settings.panes.filters.expanded = true
      embedConfig.settings.panes.filters.visible = true
    }
    if (!embedConfig.embedUrl) {
      //console.log('embed URL is missing for the selected Report')
      return
    }
    const embedContainer: HTMLElement = embedContainerRef.current
    const powerbi: powerbiClient.service.Service = window['powerbi']
    const report = powerbi.embed(
      embedContainer,
      embedConfig,
    ) as powerbiClient.Report
    // Listen for events and apply slicer filters after report is loaded
    report.on('loaded', async () => {
      // console.log('Report loaded.')
      await setSlicerFilter(report)
    })
    report.on('rendered', () => {
      //console.log('rendered')
      setInterval(() => checkSlicerFilters(report), 5000) // Run every 5 seconds
    })
    report.on('error', (event: powerbiClient.service.ICustomEvent<any>) => {
      //console.error('Error embedding report:', event.detail)
    })
  }
  const checkSlicerFilters = async (report: any) => {
    console.log('checkSlicerFilters')
    try {
      const pages: powerbiClient.Page[] = await report.getPages()
      const page = pages.find((page) => page.isActive)
      if (!page) {
        //console.error('Active page not found')
        return
      }
      const visuals: powerbiClient.VisualDescriptor[] = await page.getVisuals()
      visuals.forEach(async (visual: any) => {
        if (visual.type === 'slicer') {
          try {
            const slicerState = await visual.getSlicerState()
            //console.log('Slicer State:', slicerState)
            let selectedFromDate = ''
            let selectedToDate = ''
            slicerState.filters.forEach((filter: any) => {
              if (
                filter.target?.table === 'CalenderTable' &&
                filter.target.column === 'datestamp'
              ) {
                filter.conditions.forEach((condition: any) => {
                  if (condition.operator === 'GreaterThanOrEqual') {
                    let fromDate = new Date(condition.value)
                    fromDate.setDate(fromDate.getDate() + 1) // Add 1 day
                    selectedFromDate =
                      fromDate.toISOString().split('T')[0] + 'T00:00:00'
                    //console.log('Selected From Date:', selectedFromDate)
                    if (selectedFromDate) {
                      sessionStorage.setItem(
                        'selectedFromDate',
                        selectedFromDate,
                      )
                    }
                  } else if (condition.operator === 'LessThan') {
                    selectedToDate =
                      new Date(condition.value).toISOString().split('T')[0] +
                      'T00:00:00'
                    //console.log('Selected To Date:', selectedToDate)
                    if (selectedToDate) {
                      sessionStorage.setItem('selectedToDate', selectedToDate)
                    }
                  }
                })
              }
            })
          } catch (error) {
            //console.error('Error getting slicer state:', error)
          }
        }
      })
    } catch (error) {
      //console.error('Error checking slicer filters:', error)
    }
  }
  const setSlicerFilter = async (report: powerbiClient.Report) => {
    let date = new Date()
    let fromDate: string = new Date(date.setDate(date.getDate() - 14))
      .toISOString()
      .split('T')[0] // 14 days ago
    // console.log(fromDate)
    let toDate: string = new Date().toISOString().split('T')[0] // today's date
    // console.log(toDate)
    let storedFromDate = sessionStorage.getItem('selectedFromDate')
    let storedToDate = sessionStorage.getItem('selectedToDate')
    // console.log(storedFromDate)
    // console.log(storedToDate)
    if (!storedFromDate) {
      storedFromDate = fromDate.toString().split('T')[0] + 'T00:00:00'
    }
    if (!storedToDate) {
      storedToDate = toDate
    }
    // Initialize the filter condition array
    const conditions: models.IAdvancedFilter['conditions'] = [
      {
        operator: 'GreaterThanOrEqual',
        value: storedFromDate,
      },
    ]
    // Only add the "LessThan" condition if both storedFromDate and storedToDate are available
    if (storedFromDate && storedToDate) {
      conditions.push({
        operator: 'LessThanOrEqual',
        value: storedToDate,
      })
    }
    const filter: models.IAdvancedFilter = {
      $schema: 'http://powerbi.com/product/schema#advanced',
      filterType: models.FilterType.Advanced,
      target: {
        table: 'CalenderTable',
        column: 'datestamp',
      },
      logicalOperator: 'And',
      conditions: conditions,
    }
    try {
      const pages: powerbiClient.Page[] = await report.getPages()
      const activePage: powerbiClient.Page = pages.find(
        (page) => page.isActive,
      )!
      const visuals: powerbiClient.VisualDescriptor[] = await activePage.getVisuals()
      const slicer: powerbiClient.VisualDescriptor = visuals.find(
        (visual) =>
          visual.type === 'slicer' &&
          (visual.name === '4bf621c8d9c9c7f03a44'  ||  // ePTO || ePTOV2
            visual.name === 'b130e82820402bd21880' || // FleetSummary
            visual.name === '1226946fe38dc9ef21d3' || // Impact
            visual.name === 'baad5eddef19b74d7dd7' || // Lift
            visual.name === '4bf621c8d9c9c7f03a44' || // PX
            visual.name === '7f258d946175434384ad' || // Health
            visual.name === '93efc7bb6ec205624c28' || // Operations
            visual.name === '01297dba8eb8e3a45ca6' || // SOC
            visual.name === 'bdf3bd571b9d7600a8d5'),  // Utilization
      )!
      await slicer.setSlicerState({ filters: [filter] })
      console.log('Slicer filter applied.')
    } catch (error) {
      console.error('Error applying slicer filter:', error)
    }
  }
  useEffect(() => {
    if (powerBICredentials && selectedReportId) {
      embedReport()
    }
  }, [powerBICredentials, selectedReportId])
  return (
    <div data-id="schedules-container" className="layout-content">
      <Row gutter={8}>
        <Col xs={24} lg={24}>
          <div className="content-header page-title">
            <div style={{ display: 'flex' }}>
              <Tooltip title="Go To Previous Page">
                <BackNavigation />
              </Tooltip>
              Reports
            </div>
          </div>
        </Col>
        <Col xs={24} lg={4} className="content-header-controls">
          <div className="content-header">
            <div
              style={{
                display: 'flex',
                marginTop: '20px',
                marginBottom: '20px',
              }}
            >
              <Select
                size="large"
                style={{ width: '100%' }}
                showSearch
                placeholder="Select Report"
                options={selectOptions}
                onChange={handleSelectChange}
                value={selectedReport}
              />
            </div>
          </div>
        </Col>
        <Col xs={24} lg={24}>
          {selectedReport && (
            <div
              ref={embedContainerRef}
              className={reportClass}
              style={{ height: '600px' }}
            />
          )}
        </Col>
      </Row>
    </div>
  )
}
const mapStateToProps = (state: any) => {
  return {
    context: state.contextReducer.context,
    permissions: state.contextReducer.data,
    orgReportList: state.ReportReducer.ReportState.orgReportList,
  }
}
export default connect(mapStateToProps, actions)(Reports)
